import React from "react";
import { InputGroup, FormControl } from "react-bootstrap";
import styles from "./SearchBar.module.css";

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange }) => (
  <InputGroup className={styles.searchBarWidth}>
    <InputGroup.Text>
      <i className="pi pi-search" />
    </InputGroup.Text>
    <FormControl placeholder="Buscar" value={value} onChange={onChange} />
  </InputGroup>
);

export default SearchBar;
